import { Group, Rect, Circle, Text } from "react-konva";

// Door/Portal markers on the map (lock icon, hidden-from-players dashed styling, auto/notify-GM
// trigger badges), extracted verbatim from MapCanvas.jsx (Phase 42 refactor) — no behavior changes.
export function MapDoorsLayer({ doors, isGm, handleOverlayClick, setDoorDialog, openDoor }) {
  return (
    <>
      {(doors || []).filter((d) => isGm || d.is_visible !== false).map((d) => {
        const hiddenFromPlayers = d.is_visible === false;
        const isAutoOrNotify = d.trigger_mode && d.trigger_mode !== "manual";
        const strokeColor = d.locked && !d.broken ? "#D90429" : hiddenFromPlayers ? "#a855f7" : "#D4AF37";
        return (
          <Group
            key={d.id}
            data-testid={`door-marker-${d.id}`}
            x={d.x}
            y={d.y}
            opacity={hiddenFromPlayers ? 0.55 : 1}
            onClick={(e) => {
              if (handleOverlayClick(e)) return;
              e.cancelBubble = true;
              if (isGm) setDoorDialog({ existing: d });
              else openDoor(d);
            }}
            onTap={(e) => {
              if (handleOverlayClick(e)) return;
              e.cancelBubble = true;
              if (isGm) setDoorDialog({ existing: d });
              else openDoor(d);
            }}
          >
            <Rect x={-14} y={-18} width={28} height={36} cornerRadius={3} fill={d.locked && !d.broken ? "#3d1a1a" : hiddenFromPlayers ? "#2a1a3d" : "#3d2a1a"} stroke={strokeColor} strokeWidth={2} dash={hiddenFromPlayers ? [4, 3] : undefined} />
            <Rect x={-14} y={-18} width={28} height={36} cornerRadius={3} stroke="#1a1008" strokeWidth={1} />
            <Circle x={7} y={2} radius={2} fill={strokeColor} />
            {d.locked && !d.broken && (
              <>
                <Rect data-testid={`door-lock-icon-${d.id}`} x={-6} y={-2} width={12} height={10} cornerRadius={2} fill="#1a1008" stroke="#D90429" strokeWidth={1} />
                <Circle x={0} y={-4} radius={5} stroke="#D90429" strokeWidth={2} />
              </>
            )}
            {isGm && isAutoOrNotify && (
              <Circle data-testid={`door-auto-badge-${d.id}`} x={11} y={-15} radius={4} fill={d.trigger_mode === "auto" ? "#D4AF37" : "#3B82F6"} stroke="#1a1008" strokeWidth={1} />
            )}
            <Text text={d.name || "Door"} y={22} width={100} x={-50} align="center" fontSize={11} fill="#f1e0c5" fontStyle="bold" />
          </Group>
        );
      })}
    </>
  );
}
